<template>
    <vx-card no-shadow v-if="allRendered">
        <div class="flex flex-wrap items-center mb-6">
            <div class="w-2/24">
                <image-uploader
                    :quality="0.7"
                    :preview="false"
                    :className="['fileinput']"
                    capture="environment"
                    :debug="0"
                    doNotResize="gif"
                    :autoRotate="true"
                    outputFormat="verbose"
                    @input="setImage">
                    <label for="fileInput" slot="upload-label">
                        <span class="upload-caption">
                            <vs-avatar id="imageUpload" :src="company.logo" size="70px"  class="mr-4 mb-4" />
                        </span>
                    </label>
                </image-uploader>
            </div>
            
            <div class="w-9/12 mb-4">
                <vs-button type="border" color="danger" class="mt-5" @click="removePhoto">Remover Foto</vs-button>
                <p class="text-sm mt-2">Recomendado: 512x512 </p>
            </div>
        </div>

        <vs-divider> <feather-icon class="mr-1" icon="SettingsIcon" svgClasses="h-4 w-4 "></feather-icon> CONFIGURAÇÕES BÁSICAS <feather-icon class="ml-1" icon="SettingsIcon" svgClasses="h-4 w-4 "></feather-icon> </vs-divider>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/3 mb-12">
            <vs-checkbox class="w-full" v-model="company.allowAskForHelp"> Mostrar botão para pedir ajuda do garçom no app </vs-checkbox>
            <span class="text-sm text-danger" style="position: relative; left: 32px"> Será mostrado um botão de cor vermelha no canto inferior direito para o cliente pedir ajuda </span>
        </div>

        <vs-divider> <feather-icon class="mr-1" icon="InfoIcon" svgClasses="h-4 w-4 "></feather-icon> SOBRE A EMPRESA <feather-icon class="ml-1" icon="InfoIcon" svgClasses="h-4 w-4 "></feather-icon> </vs-divider>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/3 mb-4">
            <vs-input  v-validate.initial="{required : true}" name="RAZÃO SOCIAL" class="w-full" icon-no-border label="RAZÃO SOCIAL" v-model="company.fiscal.razaoSocial"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('RAZÃO SOCIAL')">{{ errors.first('RAZÃO SOCIAL') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/3 mb-4">
            <vs-input  v-validate.initial="{required : true}" name="NOME FANTASIA" class="w-full" icon-no-border label="NOME FANTASIA" v-model="company.name"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('NOME FANTASIA')">{{ errors.first('NOME FANTASIA') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-3/12 mb-4">
            <vs-input  v-validate.initial="{required : true}" name="CNPJ" class="w-full" icon-no-border label="CNPJ" v-model="company.fiscal.cnpj" v-mask="'##.###.###/####-##'"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('CNPJ')">{{ errors.first('CNPJ') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-3/12 mb-4">
            <vs-input  v-validate.initial="{required : true, integer : true}" name="Inscricao Estadual" class="w-full" icon-no-border label="INSCRIÇÃO ESTADUAL" v-model="company.fiscal.inscricaoEstadual"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('Inscricao Estadual')">{{ errors.first('Inscricao Estadual') }}</span>
        </div>

        <vs-divider class=" mt-base mb-base"> <feather-icon class="mr-1" icon="MapPinIcon" svgClasses="h-4 w-4 "></feather-icon> ENDEREÇO <feather-icon class="ml-1" icon="MapPinIcon" svgClasses="h-4 w-4 "></feather-icon> </vs-divider>

            <address-form v-model="company.fiscal.endereco"/>

        <vs-divider class="mt-base mb-base"> <feather-icon class="mr-1" icon="PhoneIcon" svgClasses="h-4 w-4 "></feather-icon> TELEFONES <feather-icon class="ml-1" icon="PhoneIcon" svgClasses="h-4 w-4 "></feather-icon> </vs-divider>
        
        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-4/12 mb-4">
            <vs-input v-mask="'(##) #### ####'" name="TELEFEONE" class="w-full" icon-pack="feather" icon="icon-phone" icon-no-border label="TELEFONE" v-model="company.telephone"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('TELEFONE')">{{ errors.first('TELEFONE') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-4/12 mb-4" v-if="allRendered">
            <cell-phone :number="company.cellphone" @change="(val) => company.cellphone = val" />
        </div>

        <div class="flex flex-wrap items-center">
            <vs-button class="mt-2" @click="save">Salvar Alterações</vs-button>
        </div>
    </vx-card>
</template>

<script>
import firebase from '@/firebase/firebase'
import {mask} from 'vue-the-mask'
import CellPhone from '@/components/shared/CellPhone' 
import AddressForm from '@/components/shared/AddressForm' 
import _misc from '@/assets/utils/misc.js'
import ImageUploader from 'vue-image-upload-resize'

export default {
    directives : {mask},

    components : {
        CellPhone,
        AddressForm,
        ImageUploader
    },

    data () {
        return {
            company : {
                fiscal : {
                    razaoSocial : '',
                    cnpj : '',
                    inscricaoEstadual : '',
                    endereco : {
                        logradouro : '',
                        bairro : '',
                        numero : '',
                        municipio : '',
                        uf : 'ES',
                        cep : '',
                    }
                },
                allowAskForHelp : false,
                name : '', // Trade Name
                logo : '',
                telephone : '',
                cellphone : '',
                address: ''
            },
            allRendered : false,
            noPhoto : ''
        }
    },

    mounted () {
        // this.$message.config({ top: '80px'}) 
    },

    created () {
        this.getCompanyInfo()
        this.getNoPhotoURL()
    },

    methods : {
        async save () {
            let companyId = this.$store.getters.getCompanyID;

            if(!_misc.validateCNPJ(this.company.fiscal.cnpj)) {
                this.$vs.dialog({
                    type: 'alert',
                    title: 'Erro no CNPJ',
                    text: 'Entre com um CNPJ válido.',
                    acceptText: 'Fechar'
                })
                return
            }
            let validateOk = await this.$validator.validateAll();
            if(!validateOk) return
            
            try {
                this.$vs.loading()
                this.company.address = `${this.company.fiscal.endereco.logradouro}, ${this.company.fiscal.endereco.numero}, ${this.company.fiscal.endereco.bairro}, ${this.company.fiscal.endereco.municipio}, ${this.company.fiscal.endereco.uf} - ${this.company.fiscal.endereco.cep}`;
                this.$set(this.company.fiscal, 'nomeFantasia', this.company.name)
                await firebase.firestore().collection('company').doc(companyId).update(this.company)

                this.$store.dispatch('updateCompanyInfo', this.company)
                this.$store.dispatch('updateCompanyFiscal', this.company.fiscal)
                this.$store.dispatch('updateCompanyAddress', this.company.fiscal.endereco)
                this.$store.dispatch('updateCompanyAllowAskForHelp', this.company.allowAskForHelp)
                this.$message.success('Alterações realizadas com sucesso!', 5)
            } catch (err) {
                this.$vs.dialog({
                    type: 'alert',
                    title: 'Erro',
                    text: `Erro ao salvar alterações: ${err.message}`,
                    acceptText: 'Fechar'
                })
            } finally {
                this.$vs.loading.close()
            }
        },

        namesToUpper (field) {
            this.company[field] = String(this.company[field]).split(' ').map((a) => {
                if (typeof(a[0]) != 'undefined') return a[0].toUpperCase() + a.slice(1, a.length)
            }).join(' ');
        },

        async getCompanyInfo () {
            let companyId = this.$store.getters.getCompanyID;

            try {
                this.$vs.loading()
                let companyInfo = await firebase.firestore().collection('company').doc(companyId).get()
                this.company = companyInfo.data()
            } catch (err) {
                this.$message.error(`Erro ao recuperar os dados da empresa: ${err.message}`, 5)
            } finally {
                this.allRendered = true
                this.$vs.loading.close()
            }
        },

        setImage (output) {
            var that = this
            var imageName   = _misc.generateId(50);
            let storageRef  = firebase.storage().ref().child(`companies/photos/${imageName}`)
            let uploadTask  = storageRef.putString(output.dataUrl, 'data_url');

            uploadTask.on('state_changed', function (snapshot) {
                    that.$vs.loading({
                        scale: 0.5,
                        container : "#imageUpload"
                    })
                }, function(err) {
                    that.$vs.loading.close('#imageUpload > .con-vs-loading');
                    that.$vs.dialog({
                        type: 'alert',
                        title: 'erro',
                        text: `Erro ao efetuar upload da imagem: ${err}`,
                        acceptText: 'Fechar'
                    })
                }, async function () {
                    let url = await uploadTask.snapshot.ref.getDownloadURL()
                    that.company.logo = url

                    that.$vs.loading.close('#imageUpload > .con-vs-loading');
                }
            )
        },

        async getNoPhotoURL () {
            let storageRef  = firebase.storage().ref().child(`companies/photos/no-photo.png`)
            let photoURL    = await storageRef.getDownloadURL()
            this.noPhotoURL = photoURL
        },

        async removePhoto () {
            this.$set(this.company, 'logo', this.noPhotoURL)
        },
    }
}
</script>